export default "__VITE_ASSET__DPq$D03t__"